export const translations = {
  fr: {
    // Navigation
    nav: {
      services: "Services",
      portfolio: "Portfolio",
      careers: "Carrières",
      contact: "Boutique"
    },
    
    // Hero Section
    hero: {
      welcome: "BIENVENUE DANS",
      experience: "L'EXPÉRIENCE",
      vip: "VIP.",
      subtitle: "L'excellence commence ici",
      writeUs: "ÉCRIVEZ-NOUS",
      bookAppointment: "PRENDRE RENDEZ-VOUS",
      excellence: "L'excellence commence ici"
    },
    
    // Services Section
    services: {
      title: "NOS",
      titleGold: "SERVICES",
      subtitle: "Services",
      list: [
        {
          title: "CIRE PERFECTION WAX 324 AUTO",
          description: "Application à la main de la cire, offre une protection d'une durée de 9 à 13 mois selon usage du véhicule.",
          price: "CA$79.99",
          image: "/cireperfectionwax.png"
        },
        {
          title: "REMISE À NEUF CAMION",
          description: "Lavage int/ext - Tornardo trappe à air - Balayeuse - Protecteur de vinyle - Vitre int. - Shampoing tapis/tissu (au besoin) - Shampoing moteur - Cire 324 - Lustre à pneu - Vitre ext.",
          price: "CA$299.99",
          image: "/remiseaneufcamion.png"
        },
        {
          title: "REMISE À NEUF AUTO",
          description: "Lavage int/ext - Tornardo trappe à air - Balayeuse - Protecteur de vinyle - Vitre int. - Shampoing tapis/tissu (au besoin) - Shampoing moteur - Cire 324 - Décontamination peinture - Lustre à pneu - Vitre ext.",
          price: "CA$229.99",
          image: "/remiseaneufcamion.png"
        },
        {
          title: "POSE DE PNEU AUTO (DÉJÀ MONTÉ)",
          description: "Installer 4 pneus déjà monté sur les roues - Effectuer la rotation.",
          price: "CA$49.99",
          image: "/posedepneuauto.png"
        },
        {
          title: "PNEU POSÉ + BALANCÉ (ACIER 13 À 15 POUCES)",
          description: "Montage, démontage, balancement.",
          price: "CA$59.99",
          image: "/pneu.png"
        },
        {
          title: "PNEU POSÉ + BALANCÉ (ACIER 16 POUCES)",
          description: "Montage, démontage, balancement.",
          price: "CA$64.99",
          image: "/pneu.png"
        },
        {
          title: "PNEU POSÉ + BALANCÉ (ACIER 17 À 18 POUCES)",
          description: "Montage, démontage, balancement.",
          price: "CA$69.99",
          image: "/pneu.png"
        },
        {
          title: "PNEU POSÉ + BALANCÉ (ACIER 19 À 21 POUCES)",
          description: "Montage, démontage, balancement.",
          price: "CA$79.99",
          image: "/pneu.png"
        },
        {
          title: "PNEU POSÉ + BALANCÉ (ALLIAGES 13 À 15 POUCES)",
          description: "Montage, démontage, balancement.",
          price: "CA$69.99",
          image: "/pneu2.png"
        },
        {
          title: "PNEU POSÉ + BALANCÉ (ALLIAGES 16 POUCES)",
          description: "Montage, démontage, balancement.",
          price: "CA$74.99",
          image: "/pneu2.png"
        },
        {
          title: "PNEU POSÉ + BALANCÉ (ALLIAGES 17 À 18 POUCES)",
          description: "Montage, démontage, balancement.",
          price: "CA$79.99",
          image: "/pneu2.png"
        },
        {
          title: "PNEU POSÉ + BALANCÉ (ALLIAGES 19 À 21 POUCES)",
          description: "Montage, démontage, balancement.",
          price: "CA$89.99",
          image: "/pneu2.png"
        },
        {
          title: "SHAMPOING TAPIS/TISSU (AVANT) AUTO",
          description: "Shampoing tapis/tissu sur la partie avant du véhicule.",
          price: "CA$24.99",
          image: "/shampoing.png"
        },
        {
          title: "SHAMPOING TAPIS/TISSU (AVANT) CAMION",
          description: "Shampoing tapis/tissu sur la partie avant seulement du véhicule.",
          price: "CA$39.99",
          image: "/shampoing.png"
        },
        {
          title: "VÉHICULE DE COURTOISIE",
          description: "Véhicule de courtoisie.",
          price: "CA$14.99",
          image: "/courtoisie.png"
        },
        {
          title: "SHAMPOING TAPIS/TISSU (AVANT) VUS",
          description: "Shampoing tapis/tissu sur la partie avant seulement du véhicule.",
          price: "CA$29.99",
          image: "/shampoing.png"
        },
        {
          title: "LAVAGE SPÉCIALE ENTREPRISE GÉNIO",
          description: "Lavage int./ext. de base options en sus.",
          price: "CA$69.99",
          image: "/lavagespecial.png"
        },
        {
          title: "POLISSAGE DES PHARES",
          description: "Effectuer le polissage des phares en 4 étape et +.",
          price: "CA$45.00",
          image: "/polissage.png"
        },
        {
          title: "POLISSAGE 3 ÉTAPE",
          description: "Polissage de base 3 étapes.",
          price: "Prix variable",
          image: "polissage2.png"
        },
        {
          title: "RÉPARATION DE PNEU",
          description: "Réparer le pneu défectueux.",
          price: "Prix variable",
          image: "/reparationpneu.png"
        },
        {
          title: "LAVAGE INTÉRIEUR VUS",
          description: "Dépoussiérage - Balayeuse - Vitre - Tornardo trappe.",
          price: "CA$39.99",
          image: "/lavageinterieur.png"
        },
        {
          title: "SHAMPOING TAPIS/TISSU CAMION",
          description: "Machine à tapis sur les sièges et tapis.",
          price: "CA$79.99",
          image: "/shampoing.png"
        },
        {
          title: "SHAMPOING TAPIS/TISSU VUS",
          description: "Machine à tapis sur les sièges et tapis.",
          price: "CA$59.99",
          image: "/shampoing.png"
        },
        {
          title: "SHAMPOING MOTEUR AUTO",
          description: "Dégraissage du compartiment moteur.",
          price: "CA$24.99",
          image: "/shampoingmoteur.png"
        },
        {
          title: "LAVAGE INTÉRIEUR AUTO",
          description: "Dépoussiérage - Balayeuse - Vitre - Tornardo trappe.",
          price: "CA$34.99",
          image: "/lavageinterieur.png"
        },
        {
          title: "DÉCONTAMINATION PEINTURE AUTO",
          description: "Décontamination fait à la main avec minutie.",
          price: "CA$39.99",
          image: "/decontamination.png"
        },
        {
          title: "LAVAGE EXTÉRIEUR VUS",
          description: "Jantes - Carosserie - Vitre ext.",
          price: "CA$29.99",
          image: "/lavageexterieur.png"
        },
        {
          title: "LAVAGE INT./EXT. AUTO",
          description: "Dépoussiérage - Balayeuse - Vitre int/ext - Jantes - Carosserie.",
          price: "CA$59.99",
          image: "/lavagecomplet.png"
        },
        {
          title: "PROTECTEUR DE VINYLE CAMION",
          description: "Application sur tout les plastique de l'habitacle.",
          price: "CA$34.99",
          image: "/protecteur.png"
        },
        {
          title: "SHAMPOING MOTEUR CAMION",
          description: "Dégraissage du compartiment moteur.",
          price: "CA$34.99",
          image: "/shampoingmoteur.png"
        },
        {
          title: "LAVAGE EXTÉRIEUR AUTO",
          description: "Jantes - Carosserie - Vitre ext.",
          price: "CA$24.99",
          image: "/lavageexterieur.png"
        },
        {
          title: "LUSTRE À PNEU VUS",
          description: "Application du lustre sur les 4 pneus.",
          price: "CA$14.99",
          image: "/lustre.png"
        },
        {
          title: "LUSTRE À PNEU CAMION",
          description: "Application du lustre sur les 4 pneus.",
          price: "CA$14.99",
          image: "/lustre.png"
        },
        {
          title: "LAVAGE EXTÉRIEUR CAMION",
          description: "Jantes - Carosserie - Vitre ext.",
          price: "CA$34.99",
          image: "/lavageexterieur.png"
        },
        {
          title: "REMISE À NEUF VUS",
          description: "Lavage int/ext - Tornardo trappe à air - Balayeuse - Protecteur de vinyle - Vitre int. - Shampoing tapis/tissu (au besoin) - Shampoing moteur - Cire 324 - Décontamination peinture - Lustre à pneu - Vitre ext.",
          price: "CA$249.99",
          image: "/remiseaneufcamion.png"
        },
        {
          title: "LAVAGE INTÉRIEUR CAMION",
          description: "Dépoussiérage - Balayeuse - Vitre - Tornardo trappe.",
          price: "CA$44.99",
          image: "/lavageinterieur.png"
        },
        {
          title: "DÉCONTAMINATION PEINTURE CAMION",
          description: "Décontamination fait à la main avec minutie.",
          price: "CA$49.99",
          image: "/decontamination.png"
        },
        {
          title: "LAVAGE INT./EXT. CAMION",
          description: "Dépoussiérage - Balayeuse - Vitre int/ext - Jantes - Carosserie.",
          price: "CA$79.99",
          image: "/lavagecomplet.png"
        },
        {
          title: "CIRE LIQUIDE AUTO",
          description: "Application de cire liquide.",
          price: "CA$24.99",
          image: "/cire.png"
        },
        {
          title: "CIRE LIQUIDE VUS",
          description: "Application de cire liquide.",
          price: "CA$29.99",
          image: "/cire.png"
        },
        {
          title: "LUSTRE À PNEU AUTO",
          description: "Application du lustre sur les 4 pneus.",
          price: "CA$14.99",
          image: "/lustre.png"
        },
        {
          title: "PROTECTEUR DE VINYLE VUS",
          description: "Application sur tout les plastique de l'habitacle.",
          price: "CA$29.99",
          image: "/protecteur.png"
        },
        {
          title: "SHAMPOING MOTEUR VUS",
          description: "Dégraissage du compartiment moteur.",
          price: "CA$29.99",
          image: "/shampoingmoteur.png"
        },
        {
          title: "DÉCONTAMINATION PEINTURE VUS",
          description: "Décontamination fait à la main avec minutie.",
          price: "CA$44.99",
          image: "/decontamination.png"
        },
        {
          title: "LAVAGE INT./EXT. VUS",
          description: "Dépoussiérage - Balayeuse - Vitre int/ext - Jantes - Carosserie.",
          price: "CA$69.99",
          image: "/lavagecomplet.png"
        },
        {
          title: "CIRE PERFECTION WAX 324 VUS",
          description: "Application à la main de la cire, offre une protection d'une durée de 9 à 13 mois selon usage du véhicule.",
          price: "CA$99.99",
          image: "/cireperfectionwax.png"
        },
        {
          title: "CIRE LIQUIDE CAMION",
          description: "Application de cire liquide.",
          price: "CA$34.99",
          image: "/cire.png"
        },
        {
          title: "SHAMPOING TAPIS/TISSU AUTO",
          description: "Machine à tapis sur les sièges et tapis.",
          price: "CA$49.99",
          image: "/shampoing.png"
        },
        {
          title: "CIRE PERFECTION WAX 324 CAMION",
          description: "Application à la main de la cire, offre une protection d'une durée de 9 à 13 mois selon usage du véhicule.",
          price: "CA$119.99",
          image: "/cireperfectionwax.png"
        },
        {
          title: "PROTECTEUR DE VINYLE AUTO",
          description: "Application sur tout les plastique de l'habitacle.",
          price: "CA$24.99",
          image: "/protecteur.png"
        }
      ],
      book: "Réserver",
      showMore: "Voir plus",
      showLess: "Voir moins"
    },
    
    // Showcase Section
    showcase: {
      title: "NOTRE",
      titleGold: "PORTFOLIO",
      subtitle: "Découvrez nos réalisations d'exception",
      cta: {
        title: "Votre véhicule mérite le meilleur",
        button: "Réservez maintenant"
      }
    },
    
    // Jobs Section
    jobs: {
      title: "REJOIGNEZ",
      titleGold: "L'ÉQUIPE VIP",
      subtitle: "Façonnez l'avenir de l'excellence automobile",
      benefits: {
        salary: "Salaire compétitif",
        schedule: "Horaires flexibles",
        environment: "Environnement moderne",
        team: "Équipe passionnée"
      },
      position1: {
        title: "Technicien en Esthétique Automobile",
        type: "Temps plein",
        location: "Québec, QC",
        description: "Rejoignez notre équipe d'experts pour offrir des services de détaillage haut de gamme. Formation complète fournie.",
        requirements: {
          title: "Qualifications recherchées :",
          list: [
            "Passion pour l'automobile",
            "Souci du détail",
            "Esprit d'équipe",
            "Expérience un atout"
          ]
        }
      },
      position2: {
        title: "Spécialiste Protection Céramique",
        type: "Temps plein",
        location: "Québec, QC",
        description: "Expert recherché pour l'application de traitements céramiques premium. Excellente opportunité de carrière.",
        requirements: {
          list: [
            "Expérience en détaillage",
            "Connaissance des produits céramiques",
            "Précision et minutie",
            "Certification un atout"
          ]
        }
      },
      position3: {
        title: "Conseiller Service Client VIP",
        type: "Temps plein",
        location: "Québec, QC",
        description: "Représentez l'excellence de notre marque auprès de notre clientèle haut de gamme. Excellent salaire et avantages.",
        requirements: {
          list: [
            "Expérience service client",
            "Bilinguisme (FR/EN)",
            "Excellente communication",
            "Sens de l'initiative"
          ]
        }
      },
      apply: "Postuler maintenant",
      cta: {
        title: "Vous ne voyez pas le poste idéal ?",
        subtitle: "Envoyez-nous une candidature spontanée, nous sommes toujours à la recherche de talents.",
        button: "Contactez-nous"
      }
    },
    
    // Contact Section
    contact: {
      title: "CONTACTEZ",
      titleGold: "NOUS",
      subtitle: "Prêt à vivre l'expérience VIP ? Parlons-en.",
      info: {
        title: "Informations de Contact",
        address: {
          title: "Adresse",
          content: "123 Rue de l'Excellence\nQuébec, QC G1X 1X1"
        },
        phone: {
          title: "Téléphone",
          content: "(418) 123-4567"
        },
        email: {
          title: "Email",
          content: "info@laveautovipqc.com"
        },
        hours: {
          title: "Heures d'ouverture",
          weekdays: "Lundi - Vendredi: 8h00 - 18h00",
          saturday: "Samedi: 9h00 - 17h00",
          sunday: "Dimanche: Sur rendez-vous"
        }
      },
      form: {
        name: "Votre nom complet",
        email: "Votre email",
        phone: "Votre téléphone",
        service: {
          placeholder: "Sélectionnez un service",
          option1: "Lavage Extérieur Premium",
          option2: "Détaillage Intérieur VIP",
          option3: "Protection Céramique",
          option4: "Polissage & Correction",
          option5: "Traitement Antirouille",
          option6: "Package Complet VIP"
        },
        message: "Votre message",
        submit: "Envoyer le message",
        success: "Merci pour votre message! Nous vous contacterons sous peu."
      },
      footer: {
        tagline: "L'excellence commence ici",
        copyright: "Lave-Auto VIP Club. Tous droits réservés."
      }
    }
  },
  
  en: {
    // Navigation
    nav: {
      services: "Services",
      portfolio: "Portfolio",
      careers: "Careers",
      contact: "Boutique"
    },
    
    // Hero Section
    hero: {
      welcome: "WELCOME TO",
      experience: "THE",
      vip: "VIP EXPERIENCE.",
      subtitle: "A premium platform coming soon.",
      writeUs: "WRITE TO US",
      bookAppointment: "BOOK APPOINTMENT",
      excellence: "Excellence starts here"
    },
    
    // Services Section
    services: {
      title: "OUR",
      titleGold: "SERVICES",
      subtitle: "Services",
      list: [
        {
          title: "Premium Exterior Wash",
          description: "Complete exterior cleaning with premium products for exceptional shine.",
          price: "From $79",
          image: "/cireperfectionwax.png"
        },
        {
          title: "VIP Interior Detailing",
          description: "Deep cleaning of the interior, including leather, fabrics and all corners.",
          price: "From $149",
          image: "/remiseaneufcamion.png"
        },
        {
          title: "Ceramic Protection",
          description: "Durable protection that preserves your vehicle's shine for years.",
          price: "From $599",
          image: "/pneu.png"
        },
        {
          title: "Polishing & Correction",
          description: "Removal of micro-scratches and restoration of the original paint shine.",
          price: "From $399",
          image: "/polissage.png"
        },
        {
          title: "Rust Treatment",
          description: "Complete protection against corrosion to extend your vehicle's life.",
          price: "From $199",
          image: "/protecteur.png"
        },
        {
          title: "Complete VIP Package",
          description: "The ultimate experience combining all our services for absolute perfection.",
          price: "Custom",
          image: "/lavagecomplet.png"
        }
      ],
      book: "Book",
      showMore: "Show More",
      showLess: "Show Less"
    },
    
    // Showcase Section
    showcase: {
      title: "OUR",
      titleGold: "PORTFOLIO",
      subtitle: "Discover our exceptional work",
      cta: {
        title: "Your vehicle deserves the best",
        button: "Book now"
      }
    },
    
    // Jobs Section
    jobs: {
      title: "JOIN",
      titleGold: "THE VIP TEAM",
      subtitle: "Shape the future of automotive excellence",
      benefits: {
        salary: "Competitive salary",
        schedule: "Flexible hours",
        environment: "Modern environment",
        team: "Passionate team"
      },
      position1: {
        title: "Automotive Esthetics Technician",
        type: "Full-time",
        location: "Quebec City, QC",
        description: "Join our team of experts to provide premium detailing services. Complete training provided.",
        requirements: {
          title: "Qualifications sought:",
          list: [
            "Passion for automobiles",
            "Attention to detail",
            "Team spirit",
            "Experience an asset"
          ]
        }
      },
      position2: {
        title: "Ceramic Protection Specialist",
        type: "Full-time",
        location: "Quebec City, QC",
        description: "Expert sought for premium ceramic treatment application. Excellent career opportunity.",
        requirements: {
          list: [
            "Detailing experience",
            "Knowledge of ceramic products",
            "Precision and care",
            "Certification an asset"
          ]
        }
      },
      position3: {
        title: "VIP Customer Service Advisor",
        type: "Full-time",
        location: "Quebec City, QC",
        description: "Represent our brand's excellence to our high-end clientele. Excellent salary and benefits.",
        requirements: {
          list: [
            "Customer service experience",
            "Bilingual (FR/EN)",
            "Excellent communication",
            "Initiative"
          ]
        }
      },
      apply: "Apply now",
      cta: {
        title: "Don't see the ideal position?",
        subtitle: "Send us a spontaneous application, we are always looking for talent.",
        button: "Contact us"
      }
    },
    
    // Contact Section
    contact: {
      title: "CONTACT",
      titleGold: "US",
      subtitle: "Ready for the VIP experience? Let's talk.",
      info: {
        title: "Contact Information",
        address: {
          title: "Address",
          content: "123 Excellence Street\nQuebec City, QC G1X 1X1"
        },
        phone: {
          title: "Phone",
          content: "(418) 123-4567"
        },
        email: {
          title: "Email",
          content: "info@laveautovipqc.com"
        },
        hours: {
          title: "Business Hours",
          weekdays: "Monday - Friday: 8:00 AM - 6:00 PM",
          saturday: "Saturday: 9:00 AM - 5:00 PM",
          sunday: "Sunday: By appointment"
        }
      },
      form: {
        name: "Your full name",
        email: "Your email",
        phone: "Your phone",
        service: {
          placeholder: "Select a service",
          option1: "Premium Exterior Wash",
          option2: "VIP Interior Detailing",
          option3: "Ceramic Protection",
          option4: "Polishing & Correction",
          option5: "Rust Treatment",
          option6: "Complete VIP Package"
        },
        message: "Your message",
        submit: "Send message",
        success: "Thank you for your message! We will contact you shortly."
      },
      footer: {
        tagline: "Excellence starts here",
        copyright: "Lave-Auto VIP Club. All rights reserved."
      }
    }
  }
};
